// Structured Data (JSON-LD) configurations for different page types
export const structuredDataConfigs = {
  website: {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "Cybrgate Cryptoworld",
    "description": "Professionelles Kryptowährungs-Management und Rating Framework für sichere und effiziente Investitionen",
    "url": "https://cmi.cybrgate.ch",
    "applicationCategory": "FinanceApplication",
    "operatingSystem": "Web Browser",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "EUR"
    },
    "provider": {
      "@type": "Organization",
      "name": "Cybrgate",
      "url": "https://cmi.cybrgate.ch"
    }
  },

  loginPage: {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Login - Cybrgate Cryptoworld",
    "description": "Melden Sie sich bei Ihrem Cybrgate Konto an",
    "url": "https://cmi.cybrgate.ch/login",
    "isPartOf": {
      "@type": "WebSite",
      "name": "Cybrgate Cryptoworld",
      "url": "https://cmi.cybrgate.ch"
    },
    "potentialAction": {
      "@type": "AuthorizeAction",
      "target": "https://cmi.cybrgate.ch/login",
      "name": "Login"
    }
  },

  dashboard: {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Dashboard - Cybrgate Cryptoworld",
    "description": "Überwachen Sie Ihr Kryptowährungs-Portfolio mit unserem professionellen Dashboard",
    "url": "https://cmi.cybrgate.ch/dashboard",
    "isPartOf": {
      "@type": "WebSite",
      "name": "Cybrgate Cryptoworld",
      "url": "https://cmi.cybrgate.ch"
    },
    "about": {
      "@type": "SoftwareApplication",
      "name": "Portfolio Management Dashboard",
      "applicationCategory": "FinanceApplication"
    }
  },

  ratingFramework: {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Rating Framework - Cybrgate Cryptoworld",
    "description": "Fortschrittliches Rating Framework für die Bewertung von Kryptowährungen",
    "url": "https://cmi.cybrgate.ch/rating-framework",
    "isPartOf": {
      "@type": "WebSite",
      "name": "Cybrgate Cryptoworld",
      "url": "https://cmi.cybrgate.ch"
    },
    "about": {
      "@type": "SoftwareApplication",
      "name": "Cryptocurrency Rating Framework",
      "applicationCategory": "FinanceApplication",
      "featureList": [
        "Cryptocurrency Analysis",
        "Investment Rating",
        "Risk Assessment",
        "Market Evaluation"
      ]
    }
  },

  organization: {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Cybrgate",
    "url": "https://cmi.cybrgate.ch",
    "logo": "https://cmi.cybrgate.ch/CybrgateLogoWithFont.png",
    "description": "Professional cryptocurrency management and rating framework",
    "foundingDate": "2024",
    "industry": "Financial Technology",
    "knowsAbout": [
      "Cryptocurrency",
      "Portfolio Management", 
      "Financial Analysis",
      "Investment Rating",
      "Blockchain Technology"
    ],
    "serviceType": [
      "Portfolio Management",
      "Cryptocurrency Rating",
      "Investment Analysis",
      "Risk Assessment"
    ]
  }
}

// Mapping of route meta keys to structured data configs
export const structuredDataMapping = {
  'login': 'loginPage',
  'dashboard': 'dashboard',
  'rating-framework': 'ratingFramework',
  'rating-new': 'ratingFramework',
  'rating-database': 'ratingFramework'
}

// Function to get structured data for a specific page
export function getStructuredData(metaKey) {
  const configKey = structuredDataMapping[metaKey] || 'website'
  return structuredDataConfigs[configKey]
}

// Function to inject structured data into page
export function injectStructuredData(metaKey) {
  // Remove existing structured data
  const existingScript = document.querySelector('script[type="application/ld+json"]')
  if (existingScript) {
    existingScript.remove()
  }

  // Add new structured data
  const structuredData = getStructuredData(metaKey)
  if (structuredData) {
    const script = document.createElement('script')
    script.type = 'application/ld+json'
    script.textContent = JSON.stringify(structuredData)
    document.head.appendChild(script)
  }

  // Always add organization data
  if (metaKey !== 'organization') {
    const orgScript = document.createElement('script')
    orgScript.type = 'application/ld+json'
    orgScript.textContent = JSON.stringify(structuredDataConfigs.organization)
    document.head.appendChild(orgScript)
  }
}